import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { VideoCallsActions } from '../../../video-conference/store/actions/videoCall';
import { UISocketDataMessage } from '../../models/UISocket';
import { VideoCallEventBase } from '../../models/VideoCallEventBase';
import { AppState } from '../../store/app-state';
import { SocketAction, SocketActionHandler } from '../SocketActionHandler';

export interface UISocketLeftParticipantVideoCallEventMessage extends UISocketDataMessage, VideoCallEventBase {
    userName: string;
    sessionId: string;
    isOwner: boolean;
}

@Injectable()
export class VideoCallLeftParticipantHandler implements SocketActionHandler {
    readonly action: SocketAction = 'leftParticipant';

    constructor(private store: Store<AppState>) {}

    handle(event: UISocketLeftParticipantVideoCallEventMessage): void {
        this.store.dispatch(
            VideoCallsActions.videoCallParticipantLeft({
                siteId: event.siteId,
                isOwner: event.isOwner,
            }),
        );
    }
}
